import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Form, Modal, Spinner } from 'react-bootstrap';

export function TransferPresidencyModal({
  show,
  onHide,
  date,
  members,
  selectedMemberId,
  setSelectedMemberId,
  onSubmit,
  saving,
  error,
}) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Transfer Presidency</Modal.Title>
      </Modal.Header>
      <Form onSubmit={onSubmit}>
        <Modal.Body>
          {error ? (
            <Alert variant="danger" className="mb-3">
              {error}
            </Alert>
          ) : null}
          <div className="mb-3">
            <Form.Label>Date</Form.Label>
            <Form.Control type="text" value={date} readOnly />
          </div>
          <div className="mb-3">
            <Form.Label>New President</Form.Label>
            <Form.Select
              value={selectedMemberId}
              onChange={(e) => setSelectedMemberId(e.target.value)}
              disabled={members.length === 0}
            >
              {members.length === 0 ? (
                <option value="">No eligible members</option>
              ) : (
                members.map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.username}
                  </option>
                ))
              )}
            </Form.Select>
          </div>
          <div className="small text-muted">
            Transferring presidency grants the selected member full president privileges: managing club
            features and boundaries, adding/removing members, sending broadcasts and managing events. You
            will immediately lose these privileges.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="warning" type="submit" disabled={saving || members.length === 0}>
            {saving ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Transferring...
              </>
            ) : (
              'Transfer Presidency'
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

TransferPresidencyModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  date: PropTypes.string,
  members: PropTypes.arrayOf(PropTypes.object),
  selectedMemberId: PropTypes.string,
  setSelectedMemberId: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  error: PropTypes.string,
};
